import { Component, Element, Event, EventEmitter, h, Host, Prop, State, Watch } from "@stencil/core";
import { StzhHomepageSearchSearchChangedEvent, StzhHomepageSearchSearchChangeEvent } from "../../../index";

@Component({
  tag: "stzh-homepage-search",
  styleUrl: "stzh-homepage-search.scss",
  scoped: true,
})
export class StzhHomepageSearch {
  /** Search input placeholder */
  @Prop() placeholder: string = "Suchen";

  /** Search element ID */
  @Prop() searchId: string = "anchorSearch";

  /** Search form action (if given, searchfield will be shown) */
  @Prop() searchAction: string;

  /** Search field name */
  @Prop() searchFieldName: string = "q";

  /** Search input value */
  @Prop() searchValue: string = "";

  @State() searchFilled: boolean;

  @Element() element: HTMLStzhHomepageSearchElement;

  /** Search input change event */
  @Event() stzhSearchChange: EventEmitter<StzhHomepageSearchSearchChangeEvent>;

  /** Search input changed event */
  @Event() stzhSearchChanged: EventEmitter<StzhHomepageSearchSearchChangedEvent>;

  @Watch("searchValue")
  searchValueWatcher(newValue: string) {
    this.searchFilled = newValue !== "";
  }

  private searchInput: HTMLInputElement;
  private formElement: HTMLFormElement;

  private handleSearchInput = (event: InputEvent) => {
    this.searchValue = this.searchInput.value;

    this.stzhSearchChange.emit({
      component: "stzh-homepage-search",
      originalEvent: event,
      value: this.searchValue,
    });
  };

  private handleSearchChange = (event: InputEvent) => {
    this.searchValue = this.searchInput.value;
    this.stzhSearchChanged.emit({
      component: "stzh-homepage-search",
      originalEvent: event,
      value: this.searchValue,
    });
  };

  async componentWillLoad() {
    this.searchValueWatcher(this.searchValue);
  }

  async componentDidLoad() {
    if (this.formElement) {
      this.formElement.addEventListener("animationend", () => {
        if (this.searchInput) {
          this.searchInput.focus();
        }
      });
    }
  }

  render() {
    const classes = {
      "stzh-homepage-search": true,
      "stzh-homepage-search--is-search-filled": this.searchFilled,
    };

    return (
      <Host>
        <div class={classes}>
          <div class="stzh-homepage-search__container">
            <form
              class="stzh-homepage-search__form"
              action={this.searchAction}
              role="search"
              ref={el => (this.formElement = el as HTMLFormElement)}
            >
              <label class="stzh-homepage-search__search">
                <input
                  id={this.searchId}
                  ref={el => (this.searchInput = el as HTMLInputElement)}
                  class="stzh-homepage-search__search-input"
                  type="search"
                  name={this.searchFieldName}
                  onChange={this.handleSearchChange}
                  onInput={this.handleSearchInput}
                  placeholder={this.placeholder}
                ></input>
                <stzh-icon class="stzh-homepage-search__search-icon" name="search"></stzh-icon>
              </label>
            </form>
          </div>
        </div>
      </Host>
    );
  }
}
